module.exports.wiki = {
  vi: {
    title: 'Wiki Avalon: luật chơi, vai nhân vật và bản mở rộng',
    description:
      'Khám phá luật chơi The Resistance: Avalon, năng lực nhân vật và bản mở rộng. Bắt đầu với hướng dẫn cách chơi Avalon, rồi tìm các vai và biến thể trong ván của bạn.',
    keywords: ['Hướng dẫn', 'Luật chơi Avalon', 'Cách chơi Avalon'],
  },
  pt: {
    title: 'Wiki de Avalon: regras, papéis e expansões',
    description:
      'Explore as regras de Avalon, as habilidades dos personagens e as expansões. Aprenda a jogar e consulte os papéis e variantes da sua partida.',
    keywords: ['Wiki', 'Regras', 'Como jogar'],
  },
  en: {
    title: 'Avalon Wiki: Game Rules, Character Roles & Expansions',
    description:
      'Explore The Resistance: Avalon rules, character abilities and expansions. Start with the how-to-play guide, then find the roles and variants used in your game.',
    keywords: ['Wiki', 'Rules', 'How to play'],
  },
  ru: {
    title: 'Вики Авалона: правила игры, роли и дополнения',
    description:
      'Изучите правила Авалона, способности персонажей и дополнения. Начните с руководства по игре, затем разберите роли и варианты правил вашей партии.',
    keywords: ['Вики', 'Правила', 'Как играть'],
  },
  'zh-TW': {
    title: '阿瓦隆維基：遊戲規則、角色能力與擴充',
    description: '查閱阿瓦隆遊戲規則、角色能力和擴充玩法。從新手指南開始，再了解本局角色、任務流程與可選規則。',
    keywords: ['維基', '規則', '玩法'],
  },
  'zh-CN': {
    title: '阿瓦隆维基：游戏规则、角色能力与扩展',
    description: '查阅阿瓦隆游戏规则、角色能力和扩展玩法。从新手指南开始，再了解本局角色、任务流程与可选规则。',
    keywords: ['维基', '规则', '怎么玩'],
  },
  es: {
    title: 'Wiki de Avalon: reglas, roles y expansiones',
    description:
      'Explora las reglas de Avalon, las habilidades de los personajes y las expansiones. Aprende a jugar y consulta los roles y variantes de tu partida.',
    keywords: ['Wiki', 'Reglas', 'Cómo jugar'],
  },
};
